import { Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { BottomSheetHeader } from "../../../components/BottomSheetHeader";

interface SelectionHeaderProps {
  requiredShiftCount: number;
  onBack: () => void;
}

export function SelectionHeader(props: SelectionHeaderProps) {
  const { requiredShiftCount, onBack } = props;

  return (
    <Stack>
      <BottomSheetHeader onBack={onBack} />
      <Stack sx={{ paddingX: 7, paddingTop: 2, paddingBottom: 7, alignItems: "center" }}>
        <Title variant="h3" component="h2">
          Select at least {requiredShiftCount} shifts
        </Title>
      </Stack>
    </Stack>
  );
}
